import { render } from "./EstrelaHover.vue?vue&type=template&id=e2b1cd0c"
import script from "./EstrelaHover.vue?vue&type=script&lang=js"
export * from "./EstrelaHover.vue?vue&type=script&lang=js"

import "./EstrelaHover.vue?vue&type=style&index=0&id=e2b1cd0c&lang=css"
script.render = render

export default script